import $http from '../lib/axios'

export default {
  async updateCurrentProduct({ commit }, currentProduct) {
    commit('updateCurrentProduct', currentProduct)
  },
  async logout({ commit }) {
    commit('updateUserInfo', {})
    await $http.post('/auth/logout')
  },
  async reloadInvestments({ commit }) {
    const res = await $http.get('/investment/list')
    if (res.data.code === 'SUCCESS') {
      commit('updateInvestments', res.data.data)
    }
  },
  async reloadCouponList({ commit }) {
    const res = await $http.get('/voucher/coupon/all')
    if (res.data.code === 'SUCCESS') {
      commit('updateCouponList', res.data.data)
    }
  },
  async reloadInvestor({ commit }) {
    const res = await $http.get('/investor/info')
    if (res.data.code === 'SUCCESS') {
      commit('updateUserInfo', res.data.data)
    }
  },
  async reloadAccount({ commit }) {
    const res = await $http.get('/transaction/account')
    if (res.data.code === 'SUCCESS') {
      commit('updateAccountInfo', res.data.data)
    }
  },
}
